import './Dashboard.css';

interface WaterTrackerProps {
  count: number;
  target?: number;
}

export function WaterTracker({ count, target = 4 }: WaterTrackerProps) {
  const isHydrated = count >= target;

  return (
    <div className="panel water-tracker-panel">
      <h3 className="panel-title">💧 Hydration</h3>
      <div className="water-circles">
        {Array.from({ length: target }).map((_, i) => (
          <div
            key={i}
            className={`water-circle ${i < count ? 'filled' : ''}`}
          >
            {i < count ? '💧' : '○'}
          </div>
        ))}
      </div>
      <div className="water-status">
        {isHydrated ? (
          <span className="water-hydrated">✨ Hydrated!</span>
        ) : (
          <span className="water-remaining">{target - count} more to go</span>
        )}
      </div>
      {count > target && (
        <div className="water-extra">+{count - target} extra 💧</div>
      )}
    </div>
  );
}
